import { Accordion, AccordionSummary } from '@material-ui/core';
import { guidLibGenerator } from 'core/utils/utils';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { CheckboxGroup, Icon, InputCheckbox } from 'ui';
import useAccordionTemplates from './useAccordionTemplates';

function stopPropagation(e) {
  e.stopPropagation();
}

const AccordionTemplates = ({ t, onSelecteType, resetSelection }) => {
  const { questionTemplates, onClickTemplate } = useAccordionTemplates({ onSelecteType, resetSelection });
  const instanceId = useRef(guidLibGenerator()).current;
  return (
    <div className="accordion-templates">
      {questionTemplates.map((item, i) => {
        const headerId = `${instanceId}-panel-${i}-header`;
        const contentId = `${instanceId}-panel-${i}-content`;
        return (
          <Accordion key={item.name}>
            <AccordionSummary expandIcon={<Icon name="chevron-down" size="xl" />} aria-controls={contentId} id={headerId}>
              <div className="accordion-templates__parent">
                <div className="accordion-templates__parent-select" onClick={stopPropagation} onKeyDown={stopPropagation}>
                  <InputCheckbox
                    checked={item.selected}
                    disabled={null}
                    label={<span className="sr-only">{`${t('common:Select')} ${t('lemonade:' + item.name)}`}</span>}
                    onChange={() => onClickTemplate(item)}
                  />
                </div>
                <div className={`accordion-templates__parent-text accordion-templates__parent-text--${item.selected}`}>{t('lemonade:' + item.name)}</div>
              </div>
            </AccordionSummary>
            <CheckboxGroup isLegendHidden legend={t('lemonade:' + item.name)}>
              {item.children.map((child) => {
                return (
                  <div className="accordion-templates__children" key={child.title}>
                    <div className={`accordion-templates__children-select accordion-templates__parent-text--${child.selected}`}>
                      <InputCheckbox
                        checked={child.selected}
                        disabled={null}
                        label={<span className="accordion-templates__children-text">{t('lemonade:' + child.title)}</span>}
                        onChange={() => onClickTemplate(child)}
                      />
                    </div>
                  </div>
                );
              })}
            </CheckboxGroup>
          </Accordion>
        );
      })}
    </div>
  );
};

AccordionTemplates.propTypes = {
  t: PropTypes.func,
  onSelecteType: PropTypes.func,
  resetSelection: PropTypes.bool,
};

export default AccordionTemplates;
